import { render, staticRenderFns } from "./aiDropMark.vue?vue&type=template&id=6180137d&scoped=true"
import script from "./aiDropMark.vue?vue&type=script&lang=js"
export * from "./aiDropMark.vue?vue&type=script&lang=js"
import style0 from "./aiDropMark.vue?vue&type=style&index=0&id=6180137d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6180137d",
  null
  
)

export default component.exports